import { ref, reactive } from 'vue';

const success = ref(true);
const model = reactive({});
const vhkModel = reactive({});
const failedQuestions = ref([]);

export const useStore = () => {
	return { success, model, vhkModel, failedQuestions };
};
